import script from "./Return.vue?vue&type=script&setup=true&lang=js"
export * from "./Return.vue?vue&type=script&setup=true&lang=js"

import "./Return.vue?vue&type=style&index=0&id=d094cf04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d094cf04"]])

export default __exports__